export default {
  'Sample photo': 'Exemple de photo',
  Removing: 'Suppression en cours',
  Edit: 'Éditer',
  'Adjust Picture': "Réglage de l'image",
  Restore: 'Restaurer',
  Eraser: 'Enlever',
  Size: 'Taille',
  Background: 'Arrière-plan',
  Custom: 'Fréquemment utilisé',
  Presets: 'Préréglage',
  'Add Image': 'Ajouter une image',
  'Scale to Fit': "Échelle pour s'adapter",
  'Full Width': 'Pleine largeur',
  'Full Height': 'Pleine hauteur',
  Move: 'Déplacer',
  Undo: 'Annuler',
  Redo: 'Récupérer',
  Enlarge: 'Agrandir',
  Reduce: 'Réduire',
  //2022.09.28 xxy
  BGRemover: {
    title: "HitPaw suppression d'arrière-plan en ligne",
    desc: "Supprimez facilement l'arrière-plan de vos photos 100% automatiquement et gratuitement",
    imgAlt: 'photo background remover',
    submitBtn: "Supprimer l'arrière-plan",
  },
  BGChanger: {
    title: 'HitPaw Photo Background Changer',
    desc: 'Extremely easy to change photo background 100% automatically & free',
    imgAlt: 'photo background change',
    submitBtn: 'Change Background',
  },
  "Shadows" : "Shadow",
  "Intensity" : "Opacity",
  "Radius" : "Radius",
  "Color" : "Color",
  "Move" : "Move Shadow",
  "2D move" : "2D",
  "3D move" : "3D",
  "Move the shadow" : "Drag the shadow around in the image",
    "Upload failed, click to try again": "Upload failed, click to try again",
};
